import { render, staticRenderFns } from "./BrandsMarkets.vue?vue&type=template&id=ad8d7bea&scoped=true&"
import script from "./BrandsMarkets.vue?vue&type=script&lang=js&"
export * from "./BrandsMarkets.vue?vue&type=script&lang=js&"
import style0 from "./BrandsMarkets.vue?vue&type=style&index=0&id=ad8d7bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8d7bea",
  null
  
)

export default component.exports